/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { Component, OnInit } from '@angular/core';
import { AppService } from '@core/services/app/app.service';
import { DeviceService } from '@core/services/device/device.service';

@Component({
  selector: 'app-app-info',
  templateUrl: './app-info.component.html',
  styleUrls: ['./app-info.component.scss']
})
export class AppInfoComponent implements OnInit {
  appName: string;

  appVersion: string;

  platform: string;

  osName: string;

  osVersion: string;

  constructor(
    private deviceService: DeviceService,
    private appService: AppService
  ) {}

  ngOnInit() {
    this.setData();
  }

  private async setData(): Promise<void> {
    const deviceInfo = await this.deviceService.getDeviceInfo();
    const appInfo = await this.appService.getAppInfo();

    this.appName = appInfo.name;
    this.appVersion = appInfo.version;
    this.platform = deviceInfo.platform;
    this.osName = deviceInfo.operatingSystem;
    this.osVersion = deviceInfo.osVersion;
  }
}
